import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import MDBox from 'components/MDBox';
import MDBadge from 'components/MDBadge';
import MDTypography from 'components/MDTypography';
import MDButton from 'components/MDButton';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { ItemIdentified } from 'components/ItemIdentified';
import { formatDate } from 'lib/utils';
import DataTable from 'components/Tables/DataTable';
import { AGGIORNA, RIMUOVI } from '../context/constants';

function LookupDataTable({ getData, onEditClb, onDeleteClb, reupdate, onupdate }) {
  const [data, setData] = useState({ rows: [], columns: [], fetching: true });

  const columns = [
    { Header: 'Elemento', accessor: 'element', width: '45%', align: 'left' },
    { Header: 'Status', accessor: 'status', align: 'center' },
    { Header: 'Inserito', accessor: 'inserted', align: 'center' },
    { Header: 'Action', accessor: 'action', align: 'center' },
  ];

  const onEdit = (event) => {
    event.stopPropagation();
    let { id } = event.target.dataset;
    if (!id) {
      id = event.target.parentElement.dataset.id;
    }
    if (!id) {
      //path svg
      id = event.target.parentElement.parentElement.dataset.id;
    }
    !!onEditClb && 'function' === typeof onEditClb && onEditClb(id, AGGIORNA);
    //console.log('EDITO ELEMENTO:', id);
  };
  const onDelete = (event) => {
    event.stopPropagation();
    let { id } = event.target.dataset;
    if (!id) {
      id = event.target.parentElement.dataset.id;
    }
    if (!id) {
      //path svg
      id = event.target.parentElement.parentElement.dataset.id;
    }
    !!onDeleteClb && 'function' === typeof onDeleteClb && onDeleteClb(id, RIMUOVI);
    //console.log('RIMUOVO ELEMENTO:', id);
  };

  const decorateFrontend = (dbData) => {
    if (!dbData || dbData.length <= 0) {
      return [];
    }
    const toFe = dbData.map((el) => {
      return {
        element: <ItemIdentified id={el.id} name={el.nome} />,
        status: (
          <MDBox ml={-1}>
            <MDBadge
              badgeContent={!!el.attivo ? 'on' : 'off'}
              color={!!el.attivo ? 'success' : 'error'}
              variant="gradient"
              size="sm"
            />
          </MDBox>
        ),
        inserted: (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            {formatDate(el.created_at)}
          </MDTypography>
        ),
        action: (
          <>
            <MDButton
              sx={{ m: 1 }}
              variant="gradient"
              color="warning"
              onClick={onEdit}
              data-id={el.id}
            >
              <AppRegistrationIcon />
            </MDButton>
            <MDButton
              sx={{ m: 1 }}
              variant="gradient"
              color="error"
              onClick={onDelete}
              data-id={el.id}
            >
              <DeleteForeverIcon />
            </MDButton>
          </>
        ),
      };
    });

    return toFe;
  };

  useEffect(() => {
    try {
      if (reupdate !== '') {
        getData().then((reqData) => {
          !!onupdate && typeof onupdate === 'function' && onupdate(reqData);
          const mapped = decorateFrontend(reqData);
          setData({
            columns,
            rows: mapped,
            fetching: false,
          });
        });
      }
    } catch (e) {
      console.error(`getData: error on call: ${e.message()}`);
    }
    return () => console.log('LookupDataTable unmounting...');
  }, [reupdate]);

  return (
    <DataTable
      table={{ columns: data.columns, rows: data.rows }}
      isSorted
      canSearch={false}
      entriesPerPage={{ defaultValue: 10, entries: [5, 10, 15] }}
      showTotalEntries
      noEndBorder
      loading={data.rows.length <= 0 && !!data.fetching}
    />
  );
}

LookupDataTable.defaultProps = {
  getData: () => {},
  onEditClb: () => {},
  onDeleteClb: () => {},
  reupdate: 'initial',
  onupdate: () => {},
};

LookupDataTable.propTypes = {
  getData: PropTypes.func,
  onEditClb: PropTypes.func,
  onDeleteClb: PropTypes.func,
  reupdate: PropTypes.string,
  onupdate: PropTypes.func,
};

export default LookupDataTable;
